const marginClassByBreakpoint = {
  sm: "sm:mx-[40px]",
  md: "md:mx-[40px]",
  "tablet-sm": "tablet-sm:mx-[40px]",
  "tablet-lg": "tablet-lg:mx-[40px]",
  lg: "lg:mx-[40px]",
  "laptop-sm": "laptop-sm:mx-[40px]",
  "laptop-md": "laptop-md:mx-[40px]",
  "desktop-sm": "desktop-sm:mx-[40px]",
  xl: "xl:mx-[40px]",
  "desktop-md": "desktop-md:mx-[40px]",
  "desktop-lg": "desktop-lg:mx-[40px]",
  "desktop-xlg": "desktop-xlg:mx-[40px]",
  "desktop-xl": "desktop-xl:mx-[40px]",
  "desktop-xxl": "desktop-xxl:mx-[40px]"
} as const

type Breakpoint = keyof typeof marginClassByBreakpoint

type BackgroundTileProps = {
  children: React.ReactNode
  responsiveBreakpoint?: Breakpoint
}

export function BackgroundTile({ children, responsiveBreakpoint }: BackgroundTileProps) {
  const baseClass =
    "min-w-fit bg-[#F9F9F9] rounded-[10px] w-auto mt-[23px] mb-[46px] max-laptop-sm:mb-0 pt-[21px] px-5 pb-6"

  const marginClass = responsiveBreakpoint
    ? `mx-[20px] ${marginClassByBreakpoint[responsiveBreakpoint]}`
    : "mx-[40px]"

  return <div className={`${baseClass} ${marginClass}`}>{children}</div>
}
